// src/pages/HowItWorks.js – How NextScenes Works (orientation page + moved cards from Home)

import React from "react";
import "../App.css";

export default function HowItWorks({ onNavigatePage }) {
  return (
    <div className="ns-page">
      {/* Breadcrumb */}
      <div className="ns-breadcrumb-trail">
        <button
          className="ns-breadcrumb-link"
          onClick={() => onNavigatePage && onNavigatePage("home")}
        >
          HOME
        </button>
        <span className="ns-breadcrumb-separator">/</span>
        <span className="ns-breadcrumb-current">HOW NEXTSCENES WORKS</span>
      </div>

      <header className="ns-page-header">
        <h1 className="ns-page-title">How NextScenes Works</h1>
        <p className="ns-page-subtitle">A quick guide to how stories grow here.</p>
      </header>

      {/* MOVED HERE FROM HOME */}
      <section className="ns-column" style={{ marginTop: "1rem" }}>
        <h2 className="ns-section-title">How NextScenes Works</h2>

        <div className="home-grid-4" style={{ marginTop: "1rem" }}>
          <div className="ns-card">
            <span className="step-icon">✍️</span>
            <h3 className="ns-card-title">Start a Storyline</h3>
            <p className="ns-card-text">Write the opening scene.</p>
          </div>

          <div className="ns-card">
            <span className="step-icon">📨</span>
            <h3 className="ns-card-title">Propose Scenes</h3>
            <p className="ns-card-text">Many ideas. One story.</p>
          </div>

          <div className="ns-card">
            <span className="step-icon">🗳️</span>
            <h3 className="ns-card-title">Vote</h3>
            <p className="ns-card-text">The best scene becomes canon.</p>
          </div>

          <div className="ns-card">
            <span className="step-icon">📚</span>
            <h3 className="ns-card-title">A Book Is Born</h3>
            <p className="ns-card-text">Scene by scene, a manuscript grows.</p>
          </div>
        </div>
      </section>

      {/* YOUR EXISTING CONTENT (UNCHANGED) */}
      <div className="ns-card ns-card-soft" style={{ marginTop: "1.25rem" }}>
        <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
          <strong>
            NextScenes is a collaborative storytelling platform where one writer
            guides a story, and readers help shape what comes next.
          </strong>{" "}
          Stories grow in stages. At times, the writer builds the official
          narrative. At other times, readers are invited to propose what the next
          scene could be. Decisions are visible, deliberate, and part of the
          experience.
        </p>

        <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
          This is not a race. It is a process.
        </p>

        <h2 className="ns-section-title" style={{ marginTop: "16px" }}>
          The Three Moments of a Story
        </h2>

        <div className="ns-card ns-card-soft" style={{ marginTop: "8px" }}>
          <h3 className="ns-card-title">Canon Mode</h3>
          <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
            In Canon Mode, the writer is shaping the official story. Scenes added
            here become part of the book itself. Readers can follow the narrative,
            reflect on what has been written, and prepare for what may come next.
          </p>
        </div>

        <div className="ns-card ns-card-soft" style={{ marginTop: "8px" }}>
          <h3 className="ns-card-title">Proposal Round</h3>
          <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
            At certain moments, the writer opens a Proposal Round. Readers are
            invited to suggest what the next scene could be. Other readers may
            comment, discuss, and vote on these proposals. This is a shared moment
            of imagination and judgment.
          </p>
        </div>

        <div className="ns-card ns-card-soft" style={{ marginTop: "8px" }}>
          <h3 className="ns-card-title">Decision Moment</h3>
          <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
            When the Proposal Round closes, the writer reviews the proposals and
            the community signal. One proposal may be accepted as the next canon
            scene, or the round may be cleared so the writer can continue the story
            directly.
          </p>
          <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
            Every decision is visible. Nothing happens in secret.
          </p>
        </div>

        <h2 className="ns-section-title" style={{ marginTop: "16px" }}>
          A Word About Proposals
        </h2>
        <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
          There are no wrong proposals here. Judgment is not punishment. It is how
          stories take shape.
        </p>
        <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
          Proposals are weighed, discussed, and sometimes rejected. That is not
          failure. It is part of the craft.
        </p>

        <h2 className="ns-section-title" style={{ marginTop: "16px" }}>
          What Makes NextScenes Different
        </h2>
        <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
          On NextScenes, readers don’t just consume stories. They witness how
          decisions are made.
        </p>
        <p className="ns-card-meta" style={{ fontSize: "15px", lineHeight: 1.6 }}>
          The process is part of the narrative.
        </p>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
          <button
            className="ns-button ns-button-outline"
            onClick={() => onNavigatePage && onNavigatePage("home")}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
